import * as React from 'react';
import { Mutation, MutationFn } from 'react-apollo';

import GET_COACH_AVAILABILITIES_QUERY from 'coaching/queries/GetCoachAvailabilities.gql';
import DELETE_COACHING_AVAILABILITY_EXCEPTION_MUTATION from 'coaching/mutations/DeleteCoachingAvailabilityException.gql';
import {
  DeleteCoachingAvailabilityException,
  DeleteCoachingAvailabilityExceptionVariables,
} from 'coaching/mutations/__generated__/DeleteCoachingAvailabilityException';
import ToastActions from 'actions/ToastActions';

export type Props = {
  coachUuid: string;
  startDateTime: string;
  endDateTime: string;
  children: (props: {
    deleteCoachingAvailabilityException: MutationFn<
      DeleteCoachingAvailabilityException,
      DeleteCoachingAvailabilityExceptionVariables
    >;
  }) => React.ReactNode;
};

export default function DeleteCoachAvailabilityExceptionsContainer(props: Props) {
  return (
    <Mutation<DeleteCoachingAvailabilityException, DeleteCoachingAvailabilityExceptionVariables>
      mutation={DELETE_COACHING_AVAILABILITY_EXCEPTION_MUTATION}
      onCompleted={() => ToastActions.showSuccessToast('Removed your time off block')}
      onError={error => ToastActions.showErrorToast(error.message)}
      refetchQueries={[
        {
          query: GET_COACH_AVAILABILITIES_QUERY,
          variables: {
            coachUuid: props.coachUuid,
            startDateTime: props.startDateTime,
            endDateTime: props.endDateTime,
          },
        },
      ]}>
      {deleteCoachingAvailabilityException => {
        return props.children({ deleteCoachingAvailabilityException });
      }}
    </Mutation>
  );
}
